export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      products: 'Products',
      grading: 'Grading',
      refurbishment: 'Refurbishment',
      export: 'Export',
      about: 'About',
      contact: 'Contact',
      faqs: 'FAQs',
      admin: 'Admin',
      requestList: 'Request List',
    },
    // Hero
    hero: {
      title: 'Wholesale Refurbished Computers for Latin America & the Caribbean',
      subtitle: 'Source quality refurbished laptops, desktops, and IT equipment from certified U.S. refurbishers. Browse available inventory or request custom sourcing — exported through our Miami logistics hub.',
      cta: 'Browse Available Inventory',
      secondary: 'Request Custom Sourcing',
      tagline: 'Wholesale buyers only \u2022 MOQ 10 units \u2022 Inventory rotates weekly',
    },
    // Features
    features: {
      title: 'Why LUXOR TEK',
      subtitle: 'Trusted by businesses across Latin America for reliable refurbished hardware',
      quality: {
        title: 'Quality Assured',
        desc: 'Every unit professionally refurbished, tested, cleaned, and data-wiped',
      },
      global: {
        title: 'Global Export',
        desc: 'Specialized in wholesale export to Latin America via Miami hub',
      },
      selection: {
        title: 'Wide Selection',
        desc: 'Top brands including Dell, HP, Lenovo, and Apple',
      },
      experience: {
        title: '20+ Years Experience',
        desc: 'Trusted by businesses across Latin America for reliable refurbished hardware',
      },
    },
    // Grading
    grading: {
      title: 'Our Grading System',
      subtitle: 'Transparent quality standards for every unit',
      gradeA: {
        title: 'Grade A',
        subtitle: 'Excellent Condition',
        desc: 'Like-new appearance with minimal to no cosmetic wear. Fully tested and certified.',
      },
      gradeB: {
        title: 'Grade B',
        subtitle: 'Light Wear',
        desc: 'Minor cosmetic blemishes that do not affect functionality. Fully tested and certified.',
      },
      gradeC: {
        title: 'Grade C',
        subtitle: 'Functional Wear',
        desc: 'Visible cosmetic wear but fully functional. Ideal for budget-conscious buyers.',
      },
      gradeAItems: [
        'Minimal to no cosmetic wear',
        'Original packaging when available',
        'Full functionality verified',
        'Battery health 80%+',
      ],
      gradeBItems: [
        'Minor scratches or blemishes',
        'No impact on functionality',
        'Full system testing passed',
        'Battery health 60%+',
      ],
      gradeCItems: [
        'Visible cosmetic wear',
        'Fully functional hardware',
        'Best value option',
        'Ideal for budget buyers',
      ],
      importantNote: 'Important Note',
      importantNoteText: 'All grades represent professionally refurbished equipment. Every unit undergoes our comprehensive refurbishment process regardless of grade. The grade reflects cosmetic condition only — all units are fully tested and business-ready.',
    },
    // Refurbishment
    refurbishment: {
      title: 'Our Refurbishment Process',
      subtitle: 'Business-ready equipment through rigorous quality control',
      steps: {
        step: 'Step',
        inspection: { title: 'Inspection', desc: 'Comprehensive hardware assessment' },
        cleaning: { title: 'Cleaning', desc: 'Professional deep cleaning' },
        testing: { title: 'Testing', desc: 'Full system diagnostics' },
        grading: { title: 'Grading', desc: 'Quality classification A/B/C' },
        dataWipe: { title: 'Data Wipe', desc: 'Secure NIST-compliant erasure' },
      },
      step1Items: [
        'Complete hardware assessment',
        'Component identification',
        'Initial functionality testing',
        'Damage documentation',
      ],
      step2Items: [
        'External case cleaning',
        'Screen restoration',
        'Keyboard deep cleaning',
        'Internal dust removal',
      ],
      step3Items: [
        'Full system diagnostics',
        'Stress testing components',
        'Battery health analysis',
        'Display quality verification',
      ],
      step4Items: [
        'Cosmetic condition assessment',
        'Grade A/B/C classification',
        'Quality documentation',
        'Pricing assignment',
      ],
      step5Items: [
        'NIST 800-88 compliant',
        'Certificate generation',
        'Secure data destruction',
        'Audit trail creation',
      ],
      step6Title: 'Packaging',
      step6Desc: 'Secure packaging for shipping',
      step6Items: [
        'Anti-static packaging',
        'Protective foam inserts',
        'Accessory inclusion',
        'Label and documentation',
      ],
      qualityPromise: 'Our Quality Promise',
      qualityPromiseText: 'Every refurbished unit from LUXOR TEK is business-ready. Our rigorous process ensures consistent quality across all grades, with',
      qualityWarranty: 'warranty coverage specified per quote.',
      tested: 'Tested',
      warranty: 'Warranty',
      compliantWipe: 'Compliant Wipe',
    },
    // Export
    export: {
      title: 'Export to Latin America',
      subtitle: 'Streamlined wholesale export through our Miami hub',
      timeline: '1-2 weeks processing time | 1-2 weeks delivery',
      process: {
        title: 'Export Process',
        steps: [
          'Submit your request list',
          'LUXOR TEK confirms availability',
          'Units refurbished & data-wiped',
          'Delivered to Miami forwarder',
        ],
      },
      docs: {
        title: 'Documentation Provided',
        items: [
          'Commercial Invoice',
          'Packing List',
          'Serial Number List',
          'Data Wipe Certificate',
          'HS Codes',
          'Photo Proof',
        ],
      },
    },
    // RFQ / Sourcing Model
    rfq: {
      requestQuote: 'Request Wholesale Quote',
      requestAvailability: 'Request Current Availability',
      availabilityVerified: 'Available',
      cantFindTitle: "Can't find what you need?",
      cantFindSubtitle: 'We source it.',
      cantFindDesc: 'Tell us the specifications, quantity, and destination — our team will locate the right equipment from our U.S. supplier network and prepare a custom quote.',
      customSourcing: 'Request Custom Sourcing',
      browseInventory: 'Browse Available Inventory',
      moqNote: 'Standard minimum order: 10 units',
      destinationCountry: 'Final Destination Country',
      usForwarder: 'U.S. Freight Forwarder (if applicable)',
      budgetRange: 'Target Budget / Price Range per Unit',
      timeframe: 'Desired Timeframe',
      specsRequirements: 'Specifications / Requirements',
      alternatives: 'Acceptable Alternatives (optional)',
      warrantyNote: 'Warranty terms are specified per quotation. Luxor Tek coordinates covered claims with the supplier.',
      fulfillmentNote: 'Orders are fulfilled supplier-direct via our Miami export hub. International buyers typically use their designated U.S. freight forwarder.',
      forwarderAssist: 'Need forwarder assistance? Let us know — optional coordination available.',
      dualPathTitle: 'Two Ways to Work With Us',
      dualPathSubtitle: 'Whether you see it in our catalog or need something specific, we can help.',
      browsePathTitle: 'Browse Available Inventory',
      browsePathDesc: 'Explore current stock from our U.S. refurbisher network. Filter by brand, category, grade, and specifications.',
      browsePathCta: 'Browse Catalog',
      sourcePathTitle: 'Request Custom Sourcing',
      sourcePathDesc: 'Need specific models, configurations, or quantities? Submit your requirements and our team will source it from our network.',
      sourcePathCta: 'Submit Sourcing Request',
      quoteInstead: 'Request a Quote',
    },
    // Products
    products: {
      title: 'Product Catalog',
      filters: 'Filters',
      category: 'Category',
      grade: 'Grade',
      brand: 'Brand',
      search: 'Search products...',
      noProducts: 'No products found',
      addToRequest: 'Add to Request',
      viewDetails: 'View Details',
      allCategories: 'All Categories',
      allGrades: 'All Grades',
      allBrands: 'All Brands',
      loginForPricing: 'Login to View Pricing',
    },
    // Request
    request: {
      title: 'Request List',
      empty: 'Your request list is empty',
      continue: 'Continue Browsing',
      submit: 'Submit Request',
      total: 'Total',
      quantity: 'Qty',
      remove: 'Remove',
      clear: 'Clear All',
      loginRequired: 'Login or Register to Request a Quote',
      loginRequiredDesc: 'Please login or register to view your quote cart and request pricing on our wholesale inventory.',
      loginBtn: 'Buyer Login',
      registerBtn: 'Register as Buyer',
      form: {
        title: 'Submit Your Request',
        company: 'Company Name',
        contact: 'Contact Name',
        email: 'Email',
        country: 'Country',
        city: 'City',
        notes: 'Additional Notes',
        submit: 'Submit Request',
        success: 'Request submitted successfully! We will contact you shortly.',
      },
    },
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with our sales team',
      form: {
        name: 'Your Name',
        email: 'Email Address',
        company: 'Company (Optional)',
        phone: 'Phone (Optional)',
        message: 'Your Message',
        submit: 'Send Message',
        success: 'Message sent successfully!',
      },
      email: 'Email Us',
      contactInfo: 'Contact Information',
      sendMessage: 'Send a Message',
      exportHub: 'Export Hub',
      businessHours: 'Business Hours',
      monFri: 'Monday - Friday: 9:00 AM - 6:00 PM EST',
      saturday: 'Saturday: 10:00 AM - 2:00 PM EST',
      sundayClosed: 'Sunday: Closed',
    },
    // About
    about: {
      title: 'About LUXOR TEK',
      subtitle: 'Over 20 years of experience in refurbished technology',
      mission: 'Our Mission',
      missionText: 'To provide businesses across Latin America with reliable, professionally refurbished computers at competitive prices, backed by rigorous quality control and transparent grading.',
      values: {
        title: 'Our Values',
        quality: 'Quality First',
        trust: 'Trust & Transparency',
        value: 'Value for Money',
        service: 'Customer Service',
      },
      countriesServed: 'Countries Served',
      ourStory: 'Our Story',
      ourStoryP1: 'Founded in 2004, LUXOR TEK began with a simple mission: to provide businesses in Latin America with access to reliable, professionally refurbished computers at wholesale prices.',
      ourStoryP2: 'Based in Miami, Florida, we have grown into a trusted export partner, serving buyers across 12+ countries with consistent quality, transparent grading, and secure logistics.',
      whatSetsUsApart: 'What Sets Us Apart',
      apartItems: [
        'Professional refurbishment, not consumer trade-ins',
        'Transparent grading system (A/B/C)',
        'Secure NIST-compliant data wiping',
        'Complete export documentation',
        'Miami-based export hub',
        'Warranty coverage specified per quotation',
      ],
      workWithUs: 'Work With Us',
      workWithUsText: 'Ready to source reliable refurbished equipment for your business? We work with wholesale buyers, IT distributors, and resellers across Latin America.',
      contactOurTeam: 'CONTACT OUR TEAM',
      businessClients: 'Business Clients',
    },
    // FAQs
    faqs: {
      title: 'Frequently Asked Questions',
      items: [
        { q: 'Do you keep inventory in stock?', a: 'Luxor Tek operates as a wholesale sourcing partner rather than a traditional warehouse distributor. We work directly with certified U.S. refurbishers and enterprise equipment recyclers who update inventory regularly. When an order is placed, we secure the units from our supplier network and coordinate processing and export. This model allows us to provide competitive pricing and access to a constantly refreshed inventory.' },
        { q: 'Why are your prices competitive?', a: 'Luxor Tek uses a direct sourcing model. Instead of maintaining large warehouse inventories, we source equipment directly from refurbishing partners when orders are placed. This allows us to reduce overhead costs and offer competitive wholesale pricing.' },
        { q: 'What product grades do you offer?', a: 'We follow standard refurbished grading:\n\u2022 Grade A+ \u2013 Like new condition, minimal wear\n\u2022 Grade A \u2013 Excellent condition, light cosmetic wear\n\u2022 Grade B \u2013 Moderate cosmetic wear, fully functional\n\u2022 Grade C \u2013 Noticeable cosmetic wear, fully tested and operational' },
        { q: 'How long does processing and delivery take?', a: 'Typical order timeline:\n\u2022 Processing time: 1\u20132 weeks\n\u2022 Delivery time: 1\u20132 weeks depending on destination' },
        { q: 'What is the minimum order quantity?', a: 'Our standard minimum order is 10 units. Specific requirements may vary by product type and availability. Contact us to discuss your needs.' },
        { q: 'Do you offer warranty on refurbished products?', a: 'Warranty terms vary by product and are specified in each quotation. Luxor Tek coordinates covered warranty claims directly with the supplier on your behalf.' },
        { q: 'How is payment processed?', a: 'We accept wire transfer only. After your request is approved, we will send a proforma invoice with wire instructions.' },
        { q: 'Do you ship internationally?', a: 'Yes. Luxor Tek specializes in wholesale export to Latin America and international markets through our Miami logistics hub.' },
        { q: 'Where do your products come from?', a: 'Products are sourced from certified U.S. refurbishers, enterprise asset recovery programs, and electronics recycling partners. Equipment is professionally tested and data-sanitized.' },
        { q: 'Who do you work with?', a: 'Luxor Tek works primarily with wholesalers, distributors, IT resellers, electronics retailers, and export companies.' },
        { q: 'Can I request specific configurations?', a: 'Yes, we can accommodate specific requirements. Include your specifications in the request notes.' },
      ],
      stillHaveQuestions: 'Still Have Questions?',
      cantFind: "Can't find what you're looking for? Our team is here to help.",
      contactSupport: 'CONTACT SUPPORT',
    },
    // Footer
    footer: {
      tagline: 'Premium Refurbished Computers for Latin America',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      followUs: 'Follow Us',
      rights: 'All rights reserved',
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      retry: 'Retry',
      back: 'Back',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      close: 'Close',
      units: 'units',
      items: 'items',
      item: 'item',
      products: 'products',
      backToWebsite: 'Back to website',
      backToLogin: 'Back to Login',
      backToDashboard: 'Back to Dashboard',
    },
    // Buyer Auth
    buyerAuth: {
      portal: 'Buyer Portal',
      signInAccess: 'Sign in to access wholesale pricing & orders',
      email: 'Email',
      password: 'Password',
      signingIn: 'Signing in...',
      signIn: 'Sign In',
      forgotPassword: 'Forgot your password?',
      noAccount: "Don't have an account?",
      registerWholesale: 'Register as Wholesale Buyer',
      loginSuccess: 'Login successful!',
      loginFailed: 'Login failed',
    },
    // Forgot / Reset Password
    forgotPw: {
      title: 'Reset Your Password',
      subtitle: 'Enter your email and we\'ll send a reset link',
      emailLabel: 'Email Address',
      sending: 'Sending...',
      sendLink: 'Send Reset Link',
      checkEmail: 'Check Your Email',
      sentMsg: 'If an account exists for',
      sentMsg2: ", we've sent a password reset link.",
      linkExpires: 'The link expires in 60 minutes.',
      error: 'Something went wrong. Please try again.',
    },
    resetPw: {
      title: 'Set New Password',
      subtitle: 'Choose a strong password for your account',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      resetting: 'Resetting...',
      resetBtn: 'Reset Password',
      mismatch: 'Passwords do not match',
      minLength: 'Password must be at least 8 characters',
      success: 'Password reset! You can now sign in.',
      invalidToken: 'Invalid or expired reset link',
    },
    setPw: {
      title: 'Set Your Password',
      subtitle: 'Create a password to activate your buyer account',
      password: 'Password',
      confirm: 'Confirm Password',
      setting: 'Setting up...',
      setBtn: 'Set Password & Activate',
      mismatch: 'Passwords do not match',
      minLength: 'Password must be at least 8 characters',
      success: 'Account activated! Redirecting to login...',
    },
    // Buyer Dashboard
    buyerDash: {
      approved: 'Approved',
      pending: 'Pending',
      signOut: 'Sign Out',
      browseInventory: 'Browse Inventory',
      viewWholesalePricing: 'View products with wholesale pricing',
      viewCart: 'View Cart',
      itemsInCart: 'items in cart',
      itemInCart: 'item in cart',
      quickReorder: 'Quick Reorder',
      noOrderHistory: 'No order history yet to generate quick reorders.',
      browseInventoryLink: 'Browse Inventory',
      reorder: 'Reorder',
      recentOrders: 'Recent Orders',
      noOrdersYet: 'No orders yet. Browse inventory to get started.',
      savedPreferences: 'Saved Preferences',
      interestedCategories: 'Interested Categories',
      accountSuspended: 'Account Suspended',
      accountSuspendedMsg: 'Your account has been suspended. Please contact support at sales@luxortek.com',
      cartUpdated: 'Cart updated with',
      unavailable: 'unavailable',
      failedReorder: 'Failed to reorder',
    },
    // Buyer Cart
    cart: {
      title: 'Cart',
      empty: 'Your cart is empty',
      emptyMsg: 'Browse inventory to add items',
      browseInventory: 'Browse Inventory',
      bulkImportCsv: 'Bulk Import CSV',
      clearCart: 'Clear Cart',
      uniqueNum: 'Unique #',
      brand: 'Brand',
      model: 'Model',
      specs: 'Specs',
      grade: 'Grade',
      price: 'Price',
      remove: 'Remove',
      total: 'Total',
      continueShopping: 'Continue Shopping',
      submitOrder: 'Submit Order',
      submitting: 'Submitting...',
      supplierNotice: 'Inventory and pricing subject to supplier confirmation. You will receive a proforma invoice with wire instructions.',
      removed: 'Removed from cart',
      cleared: 'Cart cleared',
      failedRemove: 'Failed to remove item',
      failedClear: 'Failed to clear cart',
      failedSubmit: 'Failed to submit order',
      csvInstructions: 'Upload a CSV with a',
      csvInstructions2: 'column. Each row adds one product to your cart.',
      downloadTemplate: 'Download sample template',
      selectFile: 'Click to select a .csv file',
      importToCart: 'Import to Cart',
      importing: 'Importing...',
      added: 'Added',
      alreadyInCart: 'Already in cart',
      errors: 'Errors',
      importFailed: 'Import failed',
      failedDownload: 'Failed to download template',
      addedToCart: 'added to cart',
      row: 'Row',
    },
    // Buyer Order Detail
    orderDetail: {
      orderProgress: 'Order Progress',
      fulfillmentNotice: 'Typical fulfillment timeline: 7\u201314 business days depending on volume and supplier confirmation.',
      notFound: 'Order not found.',
      statusUpdates: 'Status Updates',
      orderCancelled: 'Order Cancelled',
    },
    // Status labels
    status: {
      pending_approval: 'Pending',
      submitted: 'Submitted',
      proforma_sent: 'Proforma Sent',
      awaiting_wire: 'Awaiting Wire',
      paid: 'Payment Confirmed',
      payment_confirmed: 'Payment Confirmed',
      processing: 'Processing',
      shipped: 'Shipped',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    // Timeline step labels
    timeline: {
      submitted: 'Submitted',
      proforma_sent: 'Proforma Sent',
      awaiting_wire: 'Awaiting Wire',
      paid: 'Payment Confirmed',
      processing: 'Processing',
      shipped: 'Shipped',
      completed: 'Completed',
    },
    // Homepage additions
    home: {
      yearsExperience: 'Years Experience in IT Distribution',
      unitsSold: 'Refurbished Units Delivered',
      countries: 'Latin American Markets Served',
      qualityTested: 'Professionally Tested Equipment',
      productCategories: 'Product Categories',
      browseInventory: 'Browse our extensive inventory of professionally refurbished business computers',
      supplyNetworkTitle: 'U.S.-Based Supply Network',
      supplyNetworkBody: 'Luxor Tek sources inventory through a trusted U.S. supply network, with export consolidation and fulfillment managed from Miami, Florida. All orders are subject to supplier confirmation to ensure accurate grading and availability.',
      trustedBrands: 'Trusted Brands',
      browseProducts: 'Browse Products',
      contactSales: 'Contact Sales',
      // Trust strip
      trustStripCertified: 'Certified U.S. refurbisher network',
      trustStripPricing: 'Custom wholesale quotes',
      trustStripExport: 'Export logistics via Miami hub',
      trustStripTested: 'Data-wiped and professionally tested equipment',
      // Recent inventory
      recentInventoryTitle: 'Recent Inventory Examples',
      browseFullInventory: 'Browse Full Inventory',
      // Why Work With Us section
      whyWorkTitle: 'Why Work With Luxor Tek',
      whyWorkSubtitle: 'A wholesale sourcing model built for refurbished computers wholesale distributors and IT equipment export',
      whyRefurbisherNetwork: 'Direct Refurbisher Network',
      whyRefurbisherNetworkDesc: 'We partner with certified refurbishers across the United States to source quality refurbished laptops wholesale and refurbished electronics.',
      whyMiamiHub: 'Miami Export Hub',
      whyMiamiHubDesc: 'Our logistics operations are coordinated through Miami, one of the largest export gateways to Latin America for wholesale computers.',
      whyInventory: 'Large Rotating Inventory',
      whyInventoryDesc: 'Our supplier network provides access to thousands of units across multiple brands and categories of IT equipment.',
      whyPricing: 'Custom Quote Model',
      whyPricingDesc: 'Every order receives a tailored wholesale quote based on quantity, specifications, and current market conditions — no fixed public prices.',
      // Wholesale Distribution Only
      wholesaleTitle: 'Wholesale Distribution Only',
      wholesaleText: 'Luxor Tek supplies refurbished computers exclusively to:',
      wholesaleMinOrder: 'Standard minimum order: 10 units. Contact us for specific requirements.',
      wholesaleDistributors: 'IT distributors',
      wholesaleWholesalers: 'Computer wholesalers',
      wholesaleResellers: 'Retailers and resellers',
      wholesaleIntegrators: 'System integrators',
      wholesaleCorporate: 'Corporate IT buyers',
      // How It Works section
      howWorksTitle: 'How Our Process Works',
      howWorksSubtitle: 'A streamlined process from sourcing to delivery',
      howStep1: 'Supplier inventory is updated regularly',
      howStep2: 'Buyers browse available products',
      howStep3: 'Luxor Tek confirms availability with suppliers',
      howStep4: 'Orders are processed and prepared for export',
      howStep5: 'Equipment ships from our Miami logistics hub',
      howStep6: 'Delivery is completed to the buyer\u2019s destination',
      // Typical Order Timeline
      orderTimelineTitle: 'Typical Order Timeline',
      timelineStep1: 'Inventory Selection',
      timelineStep1Time: 'Same Day',
      timelineStep2: 'Supplier Confirmation',
      timelineStep2Time: '1\u20133 Days',
      timelineStep3: 'Processing & Preparation',
      timelineStep3Time: '1\u20132 Weeks',
      timelineStep4: 'International Delivery',
      timelineStep4Time: '1\u20132 Weeks',
      // Export Documentation
      exportDocsTitle: 'Export Documentation Included',
      exportDocsSubtitle: 'All export orders include:',
      exportDoc1: 'Commercial Invoice',
      exportDoc2: 'Packing List',
      exportDoc3: 'Serial Number Report',
      exportDoc4: 'Data Wipe Certificate',
      exportDoc5: 'HS Codes for customs',
      exportDoc6: 'Photo verification upon request',
      // Trust section
      trustTitle: 'Built for Wholesale IT Equipment Export',
      trustCertified: 'Certified refurbisher partners',
      trustNetwork: 'Wholesale supplier network',
      trustMiami: 'Miami export logistics hub',
      trustSupport: 'Dedicated support for distributors',
      // CTA
      ctaTitle: 'Ready to Source Wholesale Equipment?',
      downloadInventory: 'Download Catalog',
      requestQuote: 'Request a Quote',
    },
    // Export page
    exportPage: {
      miamiExportHub: 'Miami Export Hub',
      servingLatinAmerica: 'Serving Latin America',
      servingSubtitle: 'We export to all major markets in Latin America. Contact us for specific country requirements.',
    },
    // Products page extras
    productsPage: {
      exportToExcel: 'Export to Excel',
      exporting: 'Exporting...',
      addSelected: 'Add {n} Selected',
      invoiceIncluded: 'Invoice Included',
      serialList: 'Serial List',
      dataWiped: 'Data Wiped',
      approvalPending: 'Approval pending',
      loginForPricing: 'Login for pricing',
      addToCart: 'Add to Cart',
      add: 'Add',
      supplierNotice: 'Inventory and pricing subject to supplier confirmation.',
      trustQuality: '3-tier certified grading',
      trustExport: 'Export-ready via Miami hub',
      trustWire: 'Wire transfer only — no credit risk',
      trustData: 'NIST-compliant data wipe',
      qualityAssurance: 'Quality Assurance',
    },
    // Wholesale Register
    wholesale: {
      title: 'Wholesale Buyer Registration',
      subtitle: 'Register as a qualified B2B wholesale buyer',
      companyName: 'Company Name',
      contactName: 'Contact Name',
      email: 'Business Email',
      phone: 'Phone Number',
      country: 'Country',
      website: 'Company Website (Optional)',
      categories: 'Interested Categories',
      monthlyVolume: 'Estimated Monthly Volume',
      selectVolume: 'Select volume',
      comments: 'Additional Comments',
      submit: 'Submit Registration',
      submitting: 'Submitting...',
      fillRequired: 'Please fill all required fields',
      successTitle: 'Registration Received!',
      successMsg: "Thank you for registering. Our team will review your application and contact you within 1-2 business days.",
      backToHome: 'Back to Home',
    },
    // Admin Auth
    adminAuth: {
      portal: 'Admin Portal',
      signInManage: 'Sign in to manage inventory',
      createAccount: 'Create admin account',
      name: 'Name',
      email: 'Email',
      password: 'Password',
      pleaseWait: 'Please wait...',
      signIn: 'Sign In',
      createAccountBtn: 'Create Account',
      accountCreated: 'Admin account created! Please login.',
      loginSuccess: 'Login successful!',
      authFailed: 'Authentication failed',
      alreadyHaveAccount: 'Already have an account? Sign in',
      needAccount: 'Need an account? Register',
      backToWebsite: 'Back to website',
    },
    // Admin Layout / Nav
    adminNav: {
      dashboard: 'Dashboard',
      products: 'Products',
      import: 'Import',
      orders: 'Orders',
      leads: 'Leads',
      buyers: 'Buyers',
      settings: 'Settings',
      logout: 'Logout',
      language: 'Language',
    },
    // Admin Dashboard
    adminDash: {
      title: 'Dashboard',
      welcome: 'Welcome to LUXOR TEK Admin Portal',
      totalProducts: 'Total Products',
      pendingReview: 'Pending Review',
      totalOrders: 'Total Orders',
      pendingOrders: 'Pending Orders',
      quickActions: 'Quick Actions',
      importInventory: 'Import Inventory',
      viewProducts: 'View Products',
      manageOrders: 'Manage Orders',
      recentOrders: 'Recent Orders',
      viewAll: 'View All',
      noOrdersYet: 'No orders yet',
    },
    // Buyer role labels
    buyerRole: {
      buyer_approved: 'Approved',
      buyer_pending: 'Pending',
      buyer_suspended: 'Suspended',
    },
    // Lead status labels
    leadStatus: {
      new: 'New',
      pending: 'Pending',
      contacted: 'Contacted',
      approved: 'Approved',
      rejected: 'Rejected',
      converted: 'Converted',
    },
    // Admin Buyers
    adminBuyers: {
      title: 'Buyer Accounts',
      buyers: 'buyers',
      searchPlaceholder: 'Search by name, email, company...',
      allRoles: 'All Roles',
      approved: 'Approved',
      pending: 'Pending',
      suspended: 'Suspended',
      company: 'Company',
      contact: 'Contact',
      email: 'Email',
      country: 'Country',
      status: 'Status',
      created: 'Created',
      action: 'Action',
      noBuyers: 'No buyer accounts found',
      backToBuyers: 'Back to Buyers',
      buyerNotFound: 'Buyer not found',
      failedLoad: 'Failed to load buyer',
      failedUpdate: 'Failed to update status',
      statusUpdated: 'Status updated',
      totalOrders: 'Total Orders',
      totalSpent: 'Total Spent',
      actions: 'Actions',
      approve: 'Approve',
      suspend: 'Suspend',
      setPending: 'Set Pending',
      whatsapp: 'WhatsApp',
      businessType: 'Business Type',
      categories: 'Categories',
      failedLoadBuyers: 'Failed to load buyers',
    },
    // Admin Orders
    adminOrders: {
      title: 'Orders',
      searchPlaceholder: 'Search by order number or company...',
      allStatuses: 'All Statuses',
      backToOrders: 'Back to Orders',
      orderNotFound: 'Order not found',
      customerInfo: 'Customer Info',
      company: 'Company',
      contact: 'Contact',
      email: 'Email',
      whatsapp: 'WhatsApp',
      country: 'Country',
      city: 'City',
      orderNotes: 'Order Notes',
      proformaSent: 'Proforma Invoice Sent',
      supplierNotes: 'Supplier Confirmation Notes',
      supplierNotesHint: 'Internal only — not visible to buyers.',
      supplierNotesPlaceholder: 'e.g. Confirmed 12 units with supplier on 2/10. Grade A stock verified.',
      saveNotes: 'Save Notes',
      savingNotes: 'Saving...',
      notesSaved: 'Supplier confirmation notes saved',
      updateStatus: 'Update Status',
      updating: 'Updating...',
      noOrders: 'No orders found',
      items: 'Items',
      total: 'Total',
      date: 'Date',
      downloadPdf: 'Download PDF',
      resendEmail: 'Resend Email',
      resending: 'Resending...',
      emailResent: 'Status notification re-sent',
      statusHistory: 'Status History',
      sendProforma: 'Send Proforma',
      sendingProforma: 'Sending...',
      orderNumber: 'Order #',
      location: 'Location',
      units: 'Units',
      actions: 'Actions',
      view: 'View',
      loadingOrder: 'Loading order...',
      failedLoadOrders: 'Failed to load orders',
      failedLoadOrder: 'Failed to load order',
      statusUpdatedNotified: 'buyer notified',
      statusUpdatedNoEmail: 'Status updated, but notification email failed',
      statusUpdatedMsg: 'Status updated',
      failedUpdateStatus: 'Failed to update status',
      failedSaveNotes: 'Failed to save notes',
      emailResentSuccess: 'Status email resent to buyer',
      failedResendEmail: 'Failed to resend status email',
      sendProformaConfirm: 'Send proforma invoice with wire instructions to the buyer?',
      proformaSentSuccess: 'Proforma invoice sent successfully!',
      failedSendProforma: 'Failed to send proforma',
      exportPickList: 'Export Pick List',
      exportPickListDesc: 'Download Excel pick list for your provider.',
      pickListDownloaded: 'Provider pick list downloaded',
      failedExportPickList: 'Failed to export pick list',
      proformaInvoice: 'Proforma Invoice',
      proformaInvoiceDesc: 'Generate branded PDF proforma invoice.',
      proformaPdfDownloaded: 'Proforma PDF downloaded',
      failedGeneratePdf: 'Failed to generate PDF',
      nextStep: 'Next',
      contactCustomer: 'Contact Customer',
      emailCustomer: 'Email Customer',
      sendProformaDesc: 'Send proforma invoice with wire transfer instructions to the buyer.',
    },
    // Admin Products
    adminProducts: {
      title: 'Products',
      totalProducts: 'total products',
      searchPlaceholder: 'Search by SKU, model, or brand...',
      allCategories: 'All Categories',
      allGrades: 'All Grades',
      allStatuses: 'All Statuses',
      uniqueNum: 'Unique #',
      brand: 'Brand',
      model: 'Model',
      category: 'Category',
      grade: 'Grade',
      costPrice: 'Cost',
      salePrice: 'Sale Price',
      status: 'Status',
      noProducts: 'No products found',
      bulkActions: 'Bulk Actions',
      approve: 'Approve',
      delete: 'Delete',
      selected: 'selected',
      sku: 'SKU',
      actions: 'Actions',
      loadingProducts: 'Loading products...',
      failedLoadProducts: 'Failed to load products',
      productApproved: 'Product approved',
      productRejected: 'Product rejected',
      productDeleted: 'Product deleted',
      failedApprove: 'Failed to approve product',
      failedReject: 'Failed to reject product',
      failedDelete: 'Failed to delete product',
      confirmDelete: 'Delete this product permanently?',
      bulkApproveFailed: 'Bulk approve failed',
      bulkRejectFailed: 'Bulk reject failed',
      shown: 'shown',
      approveAllFiltered: 'Approve all filtered',
      rejectAllFiltered: 'Reject all filtered',
      deleteAll: 'Delete All Products',
      deleteAllTitle: 'Delete All Products',
      deleteAllWarning: 'This will permanently delete ALL products and import history. This action cannot be undone.',
      deleteAllConfirmHint: 'Type DELETE to confirm:',
      deleteAllConfirm: 'Delete Everything',
      cancel: 'Cancel',
      approveSelected: 'Approve selected',
      rejectSelected: 'Reject selected',
      clear: 'Clear',
      totalMatched: 'Total matched',
      processing: 'Processing...',
      reject: 'Reject',
      approvedStatus: 'Approved',
      pendingReviewStatus: 'Pending Review',
      rejectedStatus: 'Rejected',
      importErrorStatus: 'Import Error',
      allFilteredProducts: 'all filtered products',
      cannotUndo: 'This action cannot be undone.',
      countFailed: 'Failed to count matching products',
      filteredActionFailed: 'Filtered action failed',
      filter: 'Filter',
      allProducts: 'All products',
    },
    // Admin Leads
    adminLeads: {
      title: 'Wholesale Leads',
      leads: 'leads',
      searchPlaceholder: 'Search company, email, country...',
      allStatuses: 'All Statuses',
      company: 'Company',
      contact: 'Contact',
      email: 'Email',
      country: 'Country',
      volume: 'Volume',
      status: 'Status',
      date: 'Date',
      action: 'Action',
      noLeads: 'No leads found',
      backToLeads: 'Back to Leads',
      convertToBuyer: 'Convert to Buyer Account',
      converting: 'Converting...',
      converted: 'Lead converted to buyer account',
      failedConvert: 'Failed to convert lead',
      approve: 'Approve',
      reject: 'Reject',
      comments: 'Comments',
      categories: 'Categories',
      monthlyVolume: 'Monthly Volume',
      businessType: 'Business Type',
      website: 'Website',
      failedLoadLead: 'Failed to load lead',
      updateFailed: 'Update failed',
      notesSaved: 'Notes saved',
      failedSaveNotes: 'Failed to save notes',
      approveConfirm: 'Approve this lead and send the welcome email with inventory access?',
      leadApprovedWelcome: 'Lead approved + welcome email sent!',
      leadApprovedNoEmail: 'Lead approved but email failed to send',
      failedApprove: 'Failed to approve',
      convertConfirm: 'Convert this lead to a buyer account? A setup email will be sent.',
      buyerCreatedEmail: 'Buyer account created + setup email sent!',
      buyerCreatedNoEmail: 'Buyer account created but email failed to send',
      quickApprove: 'Quick Approve',
      quickApproveDesc: 'Approve and send branded welcome email with inventory access link',
      approveWelcome: 'Approve + Send Welcome',
      sending: 'Sending...',
      welcomeEmailSent: 'Welcome email sent',
      convertToBuyerTitle: 'Convert to Buyer',
      convertToBuyerDesc: 'Create a buyer account and send password setup email',
      convertSendSetup: 'Convert + Send Setup Email',
      alreadyConverted: 'Already Converted',
      convertedToBuyer: 'Converted to buyer account',
      manualActions: 'Manual Actions',
      approveNoEmail: 'Approve (no email)',
      adminNotes: 'Admin Notes',
      notesPlaceholder: 'Internal notes about this lead...',
      saveNotes: 'Save Notes',
      registered: 'Registered',
      updated: 'Updated',
      notSpecified: 'Not specified',
      marketingOptIn: 'Marketing Opt-In',
      yes: 'Yes',
      no: 'No',
      interestedCategories: 'Interested Categories',
      exportOptInCsv: 'Export Opt-In (CSV)',
      allCountries: 'All Countries',
      allOptIn: 'All Opt-In',
      optedIn: 'Opted In',
      type: 'Type',
      optIn: 'Opt-In',
      confirmDeleteLead: 'Delete this lead permanently?',
      leadDeleted: 'Lead deleted',
      failedDeleteLead: 'Failed to delete',
      csvExported: 'CSV exported',
      exportFailed: 'Export failed',
      leadNotFound: 'Lead not found',
      approved: 'Approved',
    },
    // Admin Settings
    adminSettings: {
      title: 'Settings',
      configurePortal: 'Configure your LUXOR TEK portal',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
      saved: 'Settings saved successfully',
      failedSave: 'Failed to save settings',
      loadingSettings: 'Loading settings...',
      contactSettings: 'Contact Settings',
      whatsappNumber: 'WhatsApp Business Number',
      adminEmailLabel: 'Admin Email',
      wireTransferDetails: 'Wire Transfer Details',
      bankName: 'Bank Name',
      beneficiaryName: 'Beneficiary Name',
      accountIban: 'Account / IBAN',
      swiftBic: 'SWIFT / BIC',
      bankAddress: 'Bank Address',
      additionalWireInstructions: 'Additional Wire Instructions',
      wireInstructionsPlaceholder: 'Additional instructions for wire transfers...',
      proformaNotes: 'Proforma Notes',
      proformaNotesPlaceholder: 'Custom notes for proforma invoices...',
      sharepointAutoSync: 'SharePoint Auto-Sync',
      sharepointAutoSyncDesc: 'Automatically import inventory files from a SharePoint folder. Uses saved mapping presets to detect category by folder/filename.',
      sharepointSync: 'SharePoint Sync',
      sharepointDesc: 'Configure automatic inventory import from SharePoint',
      tenantId: 'Tenant ID',
      clientId: 'Client ID',
      clientIdApp: 'Client ID (App Registration)',
      clientSecret: 'Client Secret',
      enterClientSecret: 'Enter client secret',
      siteUrl: 'SharePoint Site URL',
      siteUrlFormat: 'Format: yourdomain.sharepoint.com:/sites/SiteName',
      driveId: 'Drive ID (optional)',
      driveIdPlaceholder: 'Leave empty to use default document library',
      folderPath: 'Folder Path',
      folderPathHint: 'Path within the document library. Processed files moved to /processed subfolder.',
      syncInterval: 'Sync Interval (minutes)',
      every15min: 'Every 15 minutes',
      every30min: 'Every 30 minutes',
      everyHour: 'Every hour',
      every4hours: 'Every 4 hours',
      testConnection: 'Test Connection',
      testing: 'Testing...',
      syncNow: 'Sync Now',
      viewSyncLog: 'View Sync Log',
      connectionSuccessful: 'Connection Successful',
      connectionFailedMsg: 'Connection Failed',
      connectionSuccess: 'Connection successful',
      connectionFailed: 'Connection failed',
      filesFound: 'Files found:',
      syncLogTitle: 'Sync Log (Last 50)',
      closeSyncLog: 'Close',
      noSyncLogs: 'No sync logs yet.',
      syncStarted: 'Sync started',
      failedTriggerSync: 'Failed to trigger sync',
      failedLoadSyncLog: 'Failed to load sync log',
      enabled: 'Enabled',
      disabled: 'Disabled',
      syncSchedule: 'Sync Schedule',
      lastSync: 'Last Sync',
      never: 'Never',
      saveSettings: 'Save Settings',
      howWireTransferWorks: 'How Wire Transfer Works',
      wireStep1: 'Buyer submits a request',
      wireStep2: 'You review and click "Send Proforma" on the order',
      wireStep3: 'Buyer receives proforma invoice with wire instructions',
      wireStep4: 'Order status automatically updates to "Proforma Sent"',
      wireStep5: 'Track payment and update status as needed',
    },
    // Saved Lists
    savedLists: {
      title: 'Saved Lists',
      empty: 'No saved lists yet',
      emptyMsg: 'Save product selections as templates for quick reordering.',
      createNew: 'Create New List',
      editList: 'Edit List',
      name: 'List Name',
      namePlaceholder: 'e.g., School Deployment Q1',
      notes: 'Notes (optional)',
      notesPlaceholder: 'Add notes about this list...',
      items: 'Items',
      itemCount: 'items',
      lastUpdated: 'Last updated',
      applyToCart: 'Apply to Cart',
      replace: 'Replace Cart',
      merge: 'Merge into Cart',
      replaceDesc: 'Clear current cart and add all list items',
      mergeDesc: 'Add list items to existing cart',
      deleteConfirm: 'Delete this saved list?',
      deleted: 'List deleted',
      saved: 'List saved',
      updated: 'List updated',
      failedLoad: 'Failed to load saved lists',
      failedSave: 'Failed to save list',
      failedDelete: 'Failed to delete list',
      failedApply: 'Failed to apply list to cart',
      applied: 'List applied to cart',
      addedToCart: 'added to cart',
      alreadyInCart: 'already in cart',
      skipped: 'skipped',
      adjusted: 'adjusted',
      unavailable: 'Unavailable',
      qty: 'Qty',
      available: 'Avail.',
      removeItem: 'Remove item',
      noItems: 'No items in this list',
      addProducts: 'Browse products to add items',
      maxLists: 'Maximum saved lists reached',
      saveFromCart: 'Save as List',
      saveFromBulk: 'Save Selection as List',
      createOrOverwrite: 'Create new or overwrite existing',
      createNewList: 'Create new list',
      overwriteExisting: 'Overwrite existing list',
      selectList: 'Select a list to overwrite',
      saving: 'Saving...',
      applyMode: 'How to apply?',
      resultsTitle: 'Apply Results',
      skippedItems: 'Skipped Items',
      adjustedItems: 'Adjusted Items',
      requested: 'Requested',
      appliedQty: 'Applied',
      backToLists: 'Back to Lists',
      viewEdit: 'View / Edit',
    },
    // Change Password
    changePassword: {
      title: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      submit: 'Update Password',
      updating: 'Updating...',
      success: 'Password changed successfully',
      mismatch: 'New passwords do not match',
      tooShort: 'New password must be at least 8 characters',
    },
    // Admin Import
    adminImport: {
      title: 'Import Inventory',
      subtitle: 'Upload and map any Excel or CSV file to import products',
      uploadFile: 'Upload File',
      uploadTitle: 'Upload inventory file',
      uploadDesc: 'Supports Excel (.xlsx, .xls) and CSV files with any column format.',
      dragDrop: 'Drag and drop or click to upload',
      dropOrBrowse: 'Drop file here or click to browse',
      anyColumnLayout: "Any column layout accepted \u2014 you'll map columns in the next step",
      supportedFormats: 'Supported: .xlsx, .xls, .csv',
      unsupportedFormat: 'Unsupported format. Use .xlsx, .xls, or .csv',
      analyzing: 'Analyzing...',
      analyzingFile: 'Analyzing file...',
      processingImport: 'Processing...',
      selectSheet: 'Select Sheet',
      selectSheetTitle: 'Select sheet',
      selectSheetDesc: 'Choose the sheet containing your inventory data.',
      recommended: 'recommended',
      mapColumns: 'Map Columns',
      mapColumnsTitle: 'Map columns',
      mapColumnsDesc: "Map your file's columns to the system fields. Required fields are marked with *",
      presetsLabel: 'Presets:',
      saveCurrent: 'Save current',
      selectType: 'Select type...',
      notMapped: '\u2014 Not mapped \u2014',
      used: '(used)',
      preview: 'Preview',
      previewTitle: 'Preview import',
      previewData: 'Preview data',
      importing: 'Importing...',
      importLabel: 'Import',
      importComplete: 'Import complete',
      newAdded: 'New Added',
      updated: 'Updated',
      replaceCatalog: 'Replace entire catalog',
      replaceCatalogHint: 'Archives all existing products before importing. Leave unchecked to add/update.',
      imported: 'Imported',
      totalRows: 'Total rows',
      errorDetails: 'Error details',
      rows: 'rows',
      created: 'Created',
      updated: 'Updated',
      skipped: 'Skipped',
      errors: 'Errors',
      importHistory: 'Import History',
      importHistoryTitle: 'Import history',
      importHistoryDesc: 'Audit log of all inventory imports',
      noHistory: 'No import history yet',
      presets: 'Presets',
      savePreset: 'Save Preset',
      loadPreset: 'Load Preset',
      tagCategory: 'Tag category:',
      selectCategory: 'Select category...',
      categoryTrackingHint: 'Used for import history tracking',
      reviewQueueTitle: 'Review queue',
      productsReview: 'products pending review',
      showing: 'showing',
      allReviewed: 'All products reviewed',
      approveAll: 'Approve all',
      back: 'Back',
      next: 'Next',
      executeImport: 'Execute import',
      importAnotherFile: 'Import another file',
      fileAnalyzed: 'File analyzed',
      sheetsFound: 'sheet(s) found',
      failedAnalyze: 'Failed to analyze file',
      uniqueIdRequired: 'Unique # must be mapped before proceeding',
      costOrSaleRequired: 'Either Cost Price or Sale Price Override must be mapped',
      previewFailed: 'Preview failed',
      importFailed: 'Import failed',
      presetSaved: 'Preset saved',
      failedSavePreset: 'Failed to save preset',
      presetLoaded: 'Loaded preset',
      mappingsApplied: 'mappings applied',
      noMatchingColumns: 'No matching columns found for this preset',
      presetDeleted: 'Preset deleted',
      failedDeletePreset: 'Failed to delete preset',
      productApproved: 'Product approved',
      failedApprove: 'Failed to approve',
      productRejected: 'Product rejected',
      failedReject: 'Failed to reject',
      allApproved: 'All products approved',
      failedApproveAll: 'Failed to approve all',
      confirmApproveAll: 'Approve all products?',
      deleteLogConfirm: 'Delete this import log and its original file?',
      importLogDeleted: 'Import log deleted',
      failedDeleteLog: 'Failed to delete',
      downloadFailed: 'Download failed',
      issues: 'Issues',
      dateCol: 'Date',
      fileCol: 'File',
      categoryCol: 'Category',
      importedCol: 'Imported',
      failedCol: 'Failed',
      statusCol: 'Status',
      userCol: 'User',
      actionsCol: 'Actions',
      skuCol: 'SKU',
      brandCol: 'Brand',
      modelCol: 'Model',
      costCol: 'Cost',
      saleCol: 'Sale',
      gradeCol: 'Grade',
      errorCol: 'Error',
    },
  },
  es: {
    // Navigation
    nav: {
      home: 'Inicio',
      products: 'Productos',
      grading: 'Clasificación',
      refurbishment: 'Reacondicionamiento',
      export: 'Exportación',
      about: 'Nosotros',
      contact: 'Contacto',
      faqs: 'Preguntas',
      admin: 'Admin',
      requestList: 'Lista de Solicitud',
    },
    // Hero
    hero: {
      title: 'Computadoras Reacondicionadas al Por Mayor para América Latina y el Caribe',
      subtitle: 'Obtenga laptops, computadoras de escritorio y equipos de TI reacondicionados de calidad de reacondicionadores certificados de EE.UU. Explore inventario disponible o solicite abastecimiento personalizado — exportados a través de nuestro hub logístico en Miami.',
      cta: 'Ver Inventario Disponible',
      secondary: 'Solicitar Abastecimiento',
      tagline: 'Solo compradores mayoristas \u2022 Pedido mínimo 10 unidades \u2022 El inventario rota semanalmente',
    },
    // Features
    features: {
      title: 'Por qué LUXOR TEK',
      subtitle: 'De confianza para empresas en toda América Latina para hardware reacondicionado confiable',
      quality: {
        title: 'Calidad Garantizada',
        desc: 'Cada unidad reacondicionada, probada, limpiada y con datos borrados profesionalmente',
      },
      global: {
        title: 'Exportación Global',
        desc: 'Especializados en exportación mayorista a América Latina vía Miami',
      },
      selection: {
        title: 'Amplia Selección',
        desc: 'Marcas líderes incluyendo Dell, HP, Lenovo y Apple',
      },
      experience: {
        title: '20+ Años de Experiencia',
        desc: 'De confianza para empresas en toda América Latina para hardware reacondicionado confiable',
      },
    },
    // Grading
    grading: {
      title: 'Nuestro Sistema de Clasificación',
      subtitle: 'Estándares de calidad transparentes para cada unidad',
      gradeA: {
        title: 'Grado A',
        subtitle: 'Excelente Condición',
        desc: 'Apariencia casi nueva con mínimo desgaste cosmético. Completamente probado y certificado.',
      },
      gradeB: {
        title: 'Grado B',
        subtitle: 'Desgaste Leve',
        desc: 'Imperfecciones cosméticas menores que no afectan la funcionalidad. Completamente probado.',
      },
      gradeC: {
        title: 'Grado C',
        subtitle: 'Desgaste Funcional',
        desc: 'Desgaste cosmético visible pero completamente funcional. Ideal para presupuestos ajustados.',
      },
      gradeAItems: [
        'Desgaste cosmético mínimo o nulo',
        'Empaque original cuando disponible',
        'Funcionalidad completa verificada',
        'Salud de batería 80%+',
      ],
      gradeBItems: [
        'Rasguños o imperfecciones menores',
        'Sin impacto en la funcionalidad',
        'Pruebas completas del sistema aprobadas',
        'Salud de batería 60%+',
      ],
      gradeCItems: [
        'Desgaste cosmético visible',
        'Hardware completamente funcional',
        'Mejor opción de valor',
        'Ideal para compradores con presupuesto',
      ],
      importantNote: 'Nota Importante',
      importantNoteText: 'Todos los grados representan equipos profesionalmente reacondicionados. Cada unidad pasa por nuestro proceso integral de reacondicionamiento independientemente del grado. El grado refleja solo la condición cosmética — todas las unidades están completamente probadas y listas para uso empresarial.',
    },
    // Refurbishment
    refurbishment: {
      title: 'Nuestro Proceso de Reacondicionamiento',
      subtitle: 'Equipos listos para empresas a través de riguroso control de calidad',
      steps: {
        step: 'Paso',
        inspection: { title: 'Inspección', desc: 'Evaluación completa del hardware' },
        cleaning: { title: 'Limpieza', desc: 'Limpieza profunda profesional' },
        testing: { title: 'Pruebas', desc: 'Diagnósticos completos del sistema' },
        grading: { title: 'Clasificación', desc: 'Clasificación de calidad A/B/C' },
        dataWipe: { title: 'Borrado de Datos', desc: 'Borrado seguro compatible con NIST' },
      },
      step1Items: [
        'Evaluación completa del hardware',
        'Identificación de componentes',
        'Pruebas iniciales de funcionalidad',
        'Documentación de daños',
      ],
      step2Items: [
        'Limpieza externa de la carcasa',
        'Restauración de pantalla',
        'Limpieza profunda del teclado',
        'Eliminación de polvo interno',
      ],
      step3Items: [
        'Diagnósticos completos del sistema',
        'Pruebas de estrés de componentes',
        'Análisis de salud de batería',
        'Verificación de calidad de pantalla',
      ],
      step4Items: [
        'Evaluación de condición cosmética',
        'Clasificación Grado A/B/C',
        'Documentación de calidad',
        'Asignación de precios',
      ],
      step5Items: [
        'Cumplimiento NIST 800-88',
        'Generación de certificados',
        'Destrucción segura de datos',
        'Creación de registro de auditoría',
      ],
      step6Title: 'Empaque',
      step6Desc: 'Empaque seguro para envío',
      step6Items: [
        'Empaque antiestático',
        'Inserciones de espuma protectora',
        'Inclusión de accesorios',
        'Etiquetado y documentación',
      ],
      qualityPromise: 'Nuestra Promesa de Calidad',
      qualityPromiseText: 'Cada unidad reacondicionada de LUXOR TEK está lista para uso empresarial. Nuestro riguroso proceso garantiza calidad consistente en todos los grados, con',
      qualityWarranty: 'cobertura de garantía especificada por cotización.',
      tested: 'Probado',
      warranty: 'Garantía',
      compliantWipe: 'Borrado Certificado',
    },
    // Export
    export: {
      title: 'Exportación a América Latina',
      subtitle: 'Exportación mayorista optimizada a través de nuestro hub en Miami',
      timeline: '1-2 semanas de procesamiento | 1-2 semanas de entrega',
      process: {
        title: 'Proceso de Exportación',
        steps: [
          'Envíe su lista de solicitud',
          'LUXOR TEK confirma disponibilidad',
          'Unidades reacondicionadas y datos borrados',
          'Entregado al forwarder en Miami',
        ],
      },
      docs: {
        title: 'Documentación Proporcionada',
        items: [
          'Factura Comercial',
          'Lista de Empaque',
          'Lista de Números de Serie',
          'Certificado de Borrado de Datos',
          'Códigos HS',
          'Prueba Fotográfica',
        ],
      },
    },
    // Export page
    exportPage: {
      miamiExportHub: 'Centro de Exportación Miami',
      servingLatinAmerica: 'Sirviendo a América Latina',
      servingSubtitle: 'Exportamos a todos los principales mercados de América Latina. Contáctenos para requisitos específicos por país.',
    },
    // RFQ / Sourcing Model
    rfq: {
      requestQuote: 'Solicitar Cotización Mayorista',
      requestAvailability: 'Consultar Disponibilidad Actual',
      availabilityVerified: 'Disponible',
      cantFindTitle: '¿No encuentra lo que necesita?',
      cantFindSubtitle: 'Nosotros lo conseguimos.',
      cantFindDesc: 'Indíquenos las especificaciones, cantidad y destino — nuestro equipo localizará el equipo adecuado de nuestra red de proveedores en EE.UU. y preparará una cotización personalizada.',
      customSourcing: 'Solicitar Abastecimiento Personalizado',
      browseInventory: 'Ver Inventario Disponible',
      moqNote: 'Pedido mínimo estándar: 10 unidades',
      destinationCountry: 'País de Destino Final',
      usForwarder: 'Freight Forwarder en EE.UU. (si aplica)',
      budgetRange: 'Presupuesto Objetivo / Rango de Precio por Unidad',
      timeframe: 'Plazo Deseado',
      specsRequirements: 'Especificaciones / Requisitos',
      alternatives: 'Alternativas Aceptables (opcional)',
      warrantyNote: 'Los términos de garantía se especifican por cotización. Luxor Tek coordina los reclamos cubiertos con el proveedor.',
      fulfillmentNote: 'Los pedidos se despachan directo del proveedor a través de nuestro hub de exportación en Miami. Los compradores internacionales normalmente usan su freight forwarder designado en EE.UU.',
      forwarderAssist: '¿Necesita asistencia con el freight forwarder? Avísenos — coordinación opcional disponible.',
      dualPathTitle: 'Dos Formas de Trabajar Con Nosotros',
      dualPathSubtitle: 'Ya sea que lo vea en nuestro catálogo o necesite algo específico, podemos ayudar.',
      browsePathTitle: 'Ver Inventario Disponible',
      browsePathDesc: 'Explore el stock actual de nuestra red de reacondicionadores en EE.UU. Filtre por marca, categoría, grado y especificaciones.',
      browsePathCta: 'Ver Catálogo',
      sourcePathTitle: 'Solicitar Abastecimiento Personalizado',
      sourcePathDesc: '¿Necesita modelos, configuraciones o cantidades específicas? Envíe sus requisitos y nuestro equipo lo buscará en nuestra red.',
      sourcePathCta: 'Enviar Solicitud de Abastecimiento',
      quoteInstead: 'Solicitar Cotización',
    },
    // Products
    products: {
      title: 'Catálogo de Productos',
      filters: 'Filtros',
      category: 'Categoría',
      grade: 'Grado',
      brand: 'Marca',
      search: 'Buscar productos...',
      noProducts: 'No se encontraron productos',
      addToRequest: 'Agregar a Solicitud',
      viewDetails: 'Ver Detalles',
      allCategories: 'Todas las Categorías',
      allGrades: 'Todos los Grados',
      allBrands: 'Todas las Marcas',
      loginForPricing: 'Iniciar sesión para ver precios',
    },
    // Request
    request: {
      title: 'Lista de Solicitud',
      empty: 'Su lista de solicitud está vacía',
      continue: 'Continuar Navegando',
      submit: 'Enviar Solicitud',
      total: 'Total',
      quantity: 'Cant',
      remove: 'Eliminar',
      clear: 'Limpiar Todo',
      loginRequired: 'Inicie sesión o regístrese para solicitar una cotización',
      loginRequiredDesc: 'Inicie sesión o regístrese para ver su carrito de cotización y solicitar precios de nuestro inventario mayorista.',
      loginBtn: 'Iniciar Sesión',
      registerBtn: 'Registrarse como Comprador',
      form: {
        title: 'Enviar Su Solicitud',
        company: 'Nombre de la Empresa',
        contact: 'Nombre de Contacto',
        email: 'Correo Electrónico',
        country: 'País',
        city: 'Ciudad',
        notes: 'Notas Adicionales',
        submit: 'Enviar Solicitud',
        success: '¡Solicitud enviada exitosamente! Nos pondremos en contacto pronto.',
      },
    },
    // Contact
    contact: {
      title: 'Contáctenos',
      subtitle: 'Comuníquese con nuestro equipo de ventas',
      form: {
        name: 'Su Nombre',
        email: 'Correo Electrónico',
        company: 'Empresa (Opcional)',
        phone: 'Teléfono (Opcional)',
        message: 'Su Mensaje',
        submit: 'Enviar Mensaje',
        success: '¡Mensaje enviado exitosamente!',
      },
      email: 'Envíenos un Email',
      contactInfo: 'Información de Contacto',
      sendMessage: 'Enviar un Mensaje',
      exportHub: 'Centro de Exportación',
      businessHours: 'Horario de Atención',
      monFri: 'Lunes - Viernes: 9:00 AM - 6:00 PM EST',
      saturday: 'Sábado: 10:00 AM - 2:00 PM EST',
      sundayClosed: 'Domingo: Cerrado',
    },
    // About
    about: {
      title: 'Sobre LUXOR TEK',
      subtitle: 'Más de 20 años de experiencia en tecnología reacondicionada',
      mission: 'Nuestra Misión',
      missionText: 'Proporcionar a empresas en toda América Latina computadoras reacondicionadas confiables y profesionales a precios competitivos, respaldadas por riguroso control de calidad y clasificación transparente.',
      values: {
        title: 'Nuestros Valores',
        quality: 'Calidad Primero',
        trust: 'Confianza y Transparencia',
        value: 'Valor por Dinero',
        service: 'Servicio al Cliente',
      },
      countriesServed: 'Países Atendidos',
      ourStory: 'Nuestra Historia',
      ourStoryP1: 'Fundada en 2004, LUXOR TEK comenzó con una misión simple: proporcionar a las empresas en América Latina acceso a computadoras confiables y profesionalmente reacondicionadas a precios mayoristas.',
      ourStoryP2: 'Con sede en Miami, Florida, hemos crecido hasta convertirnos en un socio de exportación de confianza, sirviendo a compradores en más de 12 países con calidad consistente, clasificación transparente y logística segura.',
      whatSetsUsApart: 'Lo Que Nos Distingue',
      apartItems: [
        'Reacondicionamiento profesional, no intercambios de consumidores',
        'Sistema de clasificación transparente (A/B/C)',
        'Borrado de datos seguro conforme a NIST',
        'Documentación de exportación completa',
        'Centro de exportación en Miami',
        'Cobertura de garantía especificada por cotización',
      ],
      workWithUs: 'Trabaje Con Nosotros',
      workWithUsText: '¿Listo para obtener equipos reacondicionados confiables para su negocio? Trabajamos con compradores mayoristas, distribuidores de TI y revendedores en toda América Latina.',
      contactOurTeam: 'CONTACTAR A NUESTRO EQUIPO',
      businessClients: 'Clientes Empresariales',
    },
    // FAQs
    faqs: {
      title: 'Preguntas Frecuentes',
      items: [
        { q: '\u00bfMantienen inventario en stock?', a: 'Luxor Tek opera como socio de abastecimiento mayorista en lugar de un distribuidor tradicional con almac\u00e9n. Trabajamos directamente con reacondicionadores certificados de EE.UU. y recicladores de equipos empresariales que actualizan el inventario regularmente. Cuando se realiza un pedido, aseguramos las unidades de nuestra red de proveedores y coordinamos el procesamiento y la exportaci\u00f3n. Este modelo nos permite ofrecer precios competitivos y acceso a un inventario constantemente renovado.' },
        { q: '\u00bfPor qu\u00e9 sus precios son competitivos?', a: 'Luxor Tek utiliza un modelo de abastecimiento directo. En lugar de mantener grandes inventarios en almac\u00e9n, obtenemos equipos directamente de socios reacondicionadores cuando se realizan pedidos. Esto nos permite reducir costos generales y ofrecer precios mayoristas competitivos.' },
        { q: '\u00bfQu\u00e9 grados de producto ofrecen?', a: 'Seguimos la clasificaci\u00f3n est\u00e1ndar de reacondicionados:\n\u2022 Grado A+ \u2013 Como nuevo, desgaste m\u00ednimo\n\u2022 Grado A \u2013 Excelente condici\u00f3n, desgaste cosm\u00e9tico leve\n\u2022 Grado B \u2013 Desgaste cosm\u00e9tico moderado, completamente funcional\n\u2022 Grado C \u2013 Desgaste cosm\u00e9tico notable, completamente probado y operativo' },
        { q: '\u00bfCu\u00e1nto tarda el procesamiento y la entrega?', a: 'Cronograma t\u00edpico de pedido:\n\u2022 Tiempo de procesamiento: 1\u20132 semanas\n\u2022 Tiempo de entrega: 1\u20132 semanas seg\u00fan el destino' },
        { q: '\u00bfCu\u00e1l es la cantidad m\u00ednima de pedido?', a: 'Nuestro pedido mínimo estándar es de 10 unidades. Los requisitos específicos pueden variar según el tipo de producto y la disponibilidad. Contáctenos para discutir sus necesidades.' },
        { q: '\u00bfOfrecen garant\u00eda en productos reacondicionados?', a: 'Los términos de garantía varían según el producto y se especifican en cada cotización. Luxor Tek coordina los reclamos de garantía cubiertos directamente con el proveedor en su nombre.' },
        { q: '\u00bfC\u00f3mo se procesa el pago?', a: 'Aceptamos solo transferencia bancaria. Despu\u00e9s de aprobar su solicitud, enviaremos una factura proforma con instrucciones de transferencia.' },
        { q: '\u00bfRealizan env\u00edos internacionales?', a: 'S\u00ed. Luxor Tek se especializa en exportaci\u00f3n mayorista a Am\u00e9rica Latina y mercados internacionales a trav\u00e9s de nuestro hub log\u00edstico en Miami.' },
        { q: '\u00bfDe d\u00f3nde provienen sus productos?', a: 'Los productos provienen de reacondicionadores certificados de EE.UU., programas de recuperaci\u00f3n de activos empresariales y socios de reciclaje electr\u00f3nico. El equipo es probado profesionalmente y sanitizado de datos.' },
        { q: '\u00bfCon qui\u00e9n trabajan?', a: 'Luxor Tek trabaja principalmente con mayoristas, distribuidores, revendedores de TI, minoristas de electr\u00f3nica y empresas de exportaci\u00f3n.' },
        { q: '\u00bfPuedo solicitar configuraciones espec\u00edficas?', a: 'S\u00ed, podemos acomodar requisitos espec\u00edficos. Incluya sus especificaciones en las notas de la solicitud.' },
      ],
      stillHaveQuestions: '\u00bfA\u00fan Tiene Preguntas?',
      cantFind: '\u00bfNo encuentra lo que busca? Nuestro equipo est\u00e1 aqu\u00ed para ayudar.',
      contactSupport: 'CONTACTAR SOPORTE',
    },
    // Footer
    footer: {
      tagline: 'Computadoras Reacondicionadas Premium para América Latina',
      quickLinks: 'Enlaces Rápidos',
      contact: 'Contacto',
      followUs: 'Síguenos',
      rights: 'Todos los derechos reservados',
    },
    // Common
    common: {
      loading: 'Cargando...',
      error: 'Ocurrió un error',
      retry: 'Reintentar',
      back: 'Volver',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      view: 'Ver',
      close: 'Cerrar',
      units: 'unidades',
      items: 'artículos',
      item: 'artículo',
      products: 'productos',
      backToWebsite: 'Volver al sitio',
      backToLogin: 'Volver a Iniciar Sesión',
      backToDashboard: 'Volver al Panel',
    },
    // Buyer Auth
    buyerAuth: {
      portal: 'Portal de Compradores',
      signInAccess: 'Inicie sesión para acceder a precios mayoristas y pedidos',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      signingIn: 'Iniciando sesión...',
      signIn: 'Iniciar Sesión',
      forgotPassword: '¿Olvidó su contraseña?',
      noAccount: '¿No tiene cuenta?',
      registerWholesale: 'Registrarse como Comprador Mayorista',
      loginSuccess: '¡Inicio de sesión exitoso!',
      loginFailed: 'Error al iniciar sesión',
    },
    // Forgot / Reset Password
    forgotPw: {
      title: 'Restablecer Contraseña',
      subtitle: 'Ingrese su correo y le enviaremos un enlace de restablecimiento',
      emailLabel: 'Correo Electrónico',
      sending: 'Enviando...',
      sendLink: 'Enviar Enlace',
      checkEmail: 'Revise su Correo',
      sentMsg: 'Si existe una cuenta para',
      sentMsg2: ', hemos enviado un enlace de restablecimiento.',
      linkExpires: 'El enlace expira en 60 minutos.',
      error: 'Algo salió mal. Intente nuevamente.',
    },
    resetPw: {
      title: 'Nueva Contraseña',
      subtitle: 'Elija una contraseña segura para su cuenta',
      newPassword: 'Nueva Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      resetting: 'Restableciendo...',
      resetBtn: 'Restablecer Contraseña',
      mismatch: 'Las contraseñas no coinciden',
      minLength: 'La contraseña debe tener al menos 8 caracteres',
      success: '¡Contraseña restablecida! Ya puede iniciar sesión.',
      invalidToken: 'Enlace de restablecimiento inválido o expirado',
    },
    setPw: {
      title: 'Configure su Contraseña',
      subtitle: 'Cree una contraseña para activar su cuenta de comprador',
      password: 'Contraseña',
      confirm: 'Confirmar Contraseña',
      setting: 'Configurando...',
      setBtn: 'Configurar Contraseña y Activar',
      mismatch: 'Las contraseñas no coinciden',
      minLength: 'La contraseña debe tener al menos 8 caracteres',
      success: '¡Cuenta activada! Redirigiendo al inicio de sesión...',
    },
    // Buyer Dashboard
    buyerDash: {
      approved: 'Aprobado',
      pending: 'Pendiente',
      signOut: 'Cerrar Sesión',
      browseInventory: 'Ver Inventario',
      viewWholesalePricing: 'Ver productos con precios mayoristas',
      viewCart: 'Ver Carrito',
      itemsInCart: 'artículos en el carrito',
      itemInCart: 'artículo en el carrito',
      quickReorder: 'Reorden Rápido',
      noOrderHistory: 'No hay historial de pedidos para generar reórdenes rápidos.',
      browseInventoryLink: 'Ver Inventario',
      reorder: 'Reordenar',
      recentOrders: 'Pedidos Recientes',
      noOrdersYet: 'Sin pedidos aún. Explore el inventario para comenzar.',
      savedPreferences: 'Preferencias Guardadas',
      interestedCategories: 'Categorías de Interés',
      accountSuspended: 'Cuenta Suspendida',
      accountSuspendedMsg: 'Su cuenta ha sido suspendida. Contacte soporte en sales@luxortek.com',
      cartUpdated: 'Carrito actualizado con',
      unavailable: 'no disponibles',
      failedReorder: 'Error al reordenar',
    },
    // Buyer Cart
    cart: {
      title: 'Carrito',
      empty: 'Su carrito está vacío',
      emptyMsg: 'Explore el inventario para agregar artículos',
      browseInventory: 'Ver Inventario',
      bulkImportCsv: 'Importar CSV Masivo',
      clearCart: 'Vaciar Carrito',
      uniqueNum: 'Único #',
      brand: 'Marca',
      model: 'Modelo',
      specs: 'Espec.',
      grade: 'Grado',
      price: 'Precio',
      remove: 'Eliminar',
      total: 'Total',
      continueShopping: 'Seguir Comprando',
      submitOrder: 'Enviar Pedido',
      submitting: 'Enviando...',
      supplierNotice: 'Inventario y precios sujetos a confirmación del proveedor. Recibirá una factura proforma con instrucciones de transferencia.',
      removed: 'Eliminado del carrito',
      cleared: 'Carrito vaciado',
      failedRemove: 'Error al eliminar artículo',
      failedClear: 'Error al vaciar carrito',
      failedSubmit: 'Error al enviar pedido',
      csvInstructions: 'Suba un CSV con una columna',
      csvInstructions2: '. Cada fila agrega un producto a su carrito.',
      downloadTemplate: 'Descargar plantilla de ejemplo',
      selectFile: 'Haga clic para seleccionar un archivo .csv',
      importToCart: 'Importar al Carrito',
      importing: 'Importando...',
      added: 'Agregados',
      alreadyInCart: 'Ya en carrito',
      errors: 'Errores',
      importFailed: 'Error en importación',
      failedDownload: 'Error al descargar plantilla',
      addedToCart: 'agregados al carrito',
      row: 'Fila',
    },
    // Buyer Order Detail
    orderDetail: {
      orderProgress: 'Progreso del Pedido',
      fulfillmentNotice: 'Plazo típico de cumplimiento: 7\u201314 días hábiles según volumen y confirmación del proveedor.',
      notFound: 'Pedido no encontrado.',
      statusUpdates: 'Actualizaciones de Estado',
      orderCancelled: 'Pedido Cancelado',
    },
    // Status labels
    status: {
      pending_approval: 'Pendiente',
      submitted: 'Enviado',
      proforma_sent: 'Proforma Enviada',
      awaiting_wire: 'Esperando Transferencia',
      paid: 'Pago Confirmado',
      payment_confirmed: 'Pago Confirmado',
      processing: 'En Proceso',
      shipped: 'Enviado',
      completed: 'Completado',
      cancelled: 'Cancelado',
    },
    // Timeline step labels
    timeline: {
      submitted: 'Enviado',
      proforma_sent: 'Proforma Enviada',
      awaiting_wire: 'Esperando Transferencia',
      paid: 'Pago Confirmado',
      processing: 'En Proceso',
      shipped: 'Enviado',
      completed: 'Completado',
    },
    // Homepage additions
    home: {
      yearsExperience: 'Años de Experiencia en Distribución de TI',
      unitsSold: 'Unidades Reacondicionadas Entregadas',
      countries: 'Mercados en América Latina Atendidos',
      qualityTested: 'Equipos Probados Profesionalmente',
      productCategories: 'Categorías de Productos',
      browseInventory: 'Explore nuestro amplio inventario de computadoras empresariales profesionalmente reacondicionadas',
      supplyNetworkTitle: 'Red de Suministro en EE.UU.',
      supplyNetworkBody: 'Luxor Tek obtiene inventario a través de una red de suministro confiable en EE.UU., con consolidación de exportación y cumplimiento gestionado desde Miami, Florida. Todos los pedidos están sujetos a confirmación del proveedor para garantizar una clasificación y disponibilidad precisas.',
      trustedBrands: 'Marcas de Confianza',
      browseProducts: 'Ver Productos',
      contactSales: 'Contactar Ventas',
      // Trust strip
      trustStripCertified: 'Red certificada de reacondicionadores de EE.UU.',
      trustStripPricing: 'Cotizaciones mayoristas personalizadas',
      trustStripExport: 'Logística de exportación vía Miami',
      trustStripTested: 'Equipos con datos borrados y probados profesionalmente',
      // Recent inventory
      recentInventoryTitle: 'Ejemplos de Inventario Reciente',
      browseFullInventory: 'Ver Inventario Completo',
      // Why Work With Us
      whyWorkTitle: 'Por Qué Trabajar Con Luxor Tek',
      whyWorkSubtitle: 'Un modelo de abastecimiento mayorista diseñado para distribuidores de computadoras reacondicionadas y exportación de equipos de TI',
      whyRefurbisherNetwork: 'Red Directa de Reacondicionadores',
      whyRefurbisherNetworkDesc: 'Nos asociamos con reacondicionadores certificados en todo Estados Unidos para obtener laptops y electrónicos reacondicionados de calidad al por mayor.',
      whyMiamiHub: 'Hub de Exportación en Miami',
      whyMiamiHubDesc: 'Nuestras operaciones logísticas se coordinan desde Miami, una de las mayores puertas de exportación a América Latina.',
      whyInventory: 'Gran Inventario Rotativo',
      whyInventoryDesc: 'Nuestra red de proveedores brinda acceso a miles de unidades en múltiples marcas y categorías de equipos de TI.',
      whyPricing: 'Modelo de Cotización Personalizada',
      whyPricingDesc: 'Cada pedido recibe una cotización mayorista personalizada basada en cantidad, especificaciones y condiciones actuales del mercado — sin precios públicos fijos.',
      // Wholesale Distribution Only
      wholesaleTitle: 'Solo Distribución Mayorista',
      wholesaleText: 'Luxor Tek suministra computadoras reacondicionadas exclusivamente a:',
      wholesaleMinOrder: 'Pedido mínimo estándar: 10 unidades. Contáctenos para requisitos específicos.',
      wholesaleDistributors: 'Distribuidores de TI',
      wholesaleWholesalers: 'Mayoristas de computadoras',
      wholesaleResellers: 'Minoristas y revendedores',
      wholesaleIntegrators: 'Integradores de sistemas',
      wholesaleCorporate: 'Compradores corporativos de TI',
      // How It Works
      howWorksTitle: 'Cómo Funciona Nuestro Proceso',
      howWorksSubtitle: 'Un proceso simplificado desde el abastecimiento hasta la entrega',
      howStep1: 'El inventario de proveedores se actualiza regularmente',
      howStep2: 'Los compradores navegan los productos disponibles',
      howStep3: 'Luxor Tek confirma disponibilidad con proveedores',
      howStep4: 'Los pedidos se procesan y preparan para exportación',
      howStep5: 'El equipo se envía desde nuestro hub logístico en Miami',
      howStep6: 'La entrega se completa al destino del comprador',
      // Typical Order Timeline
      orderTimelineTitle: 'Cronograma Típico de Pedido',
      timelineStep1: 'Selección de Inventario',
      timelineStep1Time: 'Mismo Día',
      timelineStep2: 'Confirmación del Proveedor',
      timelineStep2Time: '1–3 Días',
      timelineStep3: 'Procesamiento y Preparación',
      timelineStep3Time: '1–2 Semanas',
      timelineStep4: 'Entrega Internacional',
      timelineStep4Time: '1–2 Semanas',
      // Export Documentation
      exportDocsTitle: 'Documentación de Exportación Incluida',
      exportDocsSubtitle: 'Todos los pedidos de exportación incluyen:',
      exportDoc1: 'Factura Comercial',
      exportDoc2: 'Lista de Empaque',
      exportDoc3: 'Reporte de Números de Serie',
      exportDoc4: 'Certificado de Borrado de Datos',
      exportDoc5: 'Códigos HS para aduanas',
      exportDoc6: 'Verificación fotográfica bajo solicitud',
      // Trust
      trustTitle: 'Diseñado para Exportación Mayorista de Equipos de TI',
      trustCertified: 'Socios reacondicionadores certificados',
      trustNetwork: 'Red de proveedores mayoristas',
      trustMiami: 'Hub logístico de exportación en Miami',
      trustSupport: 'Soporte dedicado para distribuidores',
      // CTA
      ctaTitle: '¿Listo para Obtener Equipos al Por Mayor?',
      downloadInventory: 'Descargar Catálogo',
      requestQuote: 'Solicitar Cotización',
    },
    // Products page extras
    productsPage: {
      exportToExcel: 'Exportar Excel',
      exporting: 'Exportando...',
      addSelected: 'Agregar {n} seleccionados',
      invoiceIncluded: 'Factura incluida',
      serialList: 'Lista de seriales',
      dataWiped: 'Datos eliminados',
      approvalPending: 'Aprobación pendiente',
      loginForPricing: 'Iniciar sesión para precios',
      addToCart: 'Agregar al carrito',
      add: 'Agregar',
      supplierNotice: 'Inventario y precios sujetos a confirmación del proveedor.',
      trustQuality: 'Clasificación certificada de 3 niveles',
      trustExport: 'Listo para exportar vía Miami',
      trustWire: 'Solo transferencia — sin riesgo crediticio',
      trustData: 'Borrado de datos compatible con NIST',
      qualityAssurance: 'Garantía de Calidad',
    },
    // Wholesale Register
    wholesale: {
      title: 'Registro de Comprador Mayorista',
      subtitle: 'Regístrese como comprador mayorista B2B calificado',
      companyName: 'Nombre de la Empresa',
      contactName: 'Nombre de Contacto',
      email: 'Correo Empresarial',
      phone: 'Teléfono',
      country: 'País',
      website: 'Sitio Web de la Empresa (Opcional)',
      categories: 'Categorías de Interés',
      monthlyVolume: 'Volumen Mensual Estimado',
      selectVolume: 'Seleccionar volumen',
      comments: 'Comentarios Adicionales',
      submit: 'Enviar Registro',
      submitting: 'Enviando...',
      fillRequired: 'Complete todos los campos requeridos',
      successTitle: '¡Registro Recibido!',
      successMsg: 'Gracias por registrarse. Nuestro equipo revisará su solicitud y lo contactará en 1-2 días hábiles.',
      backToHome: 'Volver al Inicio',
    },
    // Admin Auth
    adminAuth: {
      portal: 'Portal de Administración',
      signInManage: 'Inicie sesión para gestionar inventario',
      createAccount: 'Crear cuenta de administrador',
      name: 'Nombre',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      pleaseWait: 'Espere...',
      signIn: 'Iniciar Sesión',
      createAccountBtn: 'Crear Cuenta',
      accountCreated: '¡Cuenta de administrador creada! Inicie sesión.',
      loginSuccess: '¡Inicio de sesión exitoso!',
      authFailed: 'Autenticación fallida',
      alreadyHaveAccount: '¿Ya tiene cuenta? Iniciar sesión',
      needAccount: '¿Necesita una cuenta? Registrarse',
      backToWebsite: 'Volver al sitio',
    },
    // Admin Layout / Nav
    adminNav: {
      dashboard: 'Panel',
      products: 'Productos',
      import: 'Importar',
      orders: 'Pedidos',
      leads: 'Prospectos',
      buyers: 'Compradores',
      settings: 'Configuración',
      logout: 'Cerrar Sesión',
      language: 'Idioma',
    },
    // Admin Dashboard
    adminDash: {
      title: 'Panel',
      welcome: 'Bienvenido al Portal de Administración LUXOR TEK',
      totalProducts: 'Total de Productos',
      pendingReview: 'Pendientes de Revisión',
      totalOrders: 'Total de Pedidos',
      pendingOrders: 'Pedidos Pendientes',
      quickActions: 'Acciones Rápidas',
      importInventory: 'Importar Inventario',
      viewProducts: 'Ver Productos',
      manageOrders: 'Gestionar Pedidos',
      recentOrders: 'Pedidos Recientes',
      viewAll: 'Ver Todos',
      noOrdersYet: 'Sin pedidos aún',
    },
    // Buyer role labels
    buyerRole: {
      buyer_approved: 'Aprobado',
      buyer_pending: 'Pendiente',
      buyer_suspended: 'Suspendido',
    },
    // Lead status labels
    leadStatus: {
      new: 'Nuevo',
      pending: 'Pendiente',
      contacted: 'Contactado',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      converted: 'Convertido',
    },
    // Admin Buyers
    adminBuyers: {
      title: 'Cuentas de Compradores',
      buyers: 'compradores',
      searchPlaceholder: 'Buscar por nombre, correo, empresa...',
      allRoles: 'Todos los Roles',
      approved: 'Aprobado',
      pending: 'Pendiente',
      suspended: 'Suspendido',
      company: 'Empresa',
      contact: 'Contacto',
      email: 'Correo',
      country: 'País',
      status: 'Estado',
      created: 'Creado',
      action: 'Acción',
      noBuyers: 'No se encontraron cuentas de compradores',
      backToBuyers: 'Volver a Compradores',
      buyerNotFound: 'Comprador no encontrado',
      failedLoad: 'Error al cargar comprador',
      failedUpdate: 'Error al actualizar estado',
      statusUpdated: 'Estado actualizado',
      totalOrders: 'Total de Pedidos',
      totalSpent: 'Total Gastado',
      actions: 'Acciones',
      approve: 'Aprobar',
      suspend: 'Suspender',
      setPending: 'Poner en Pendiente',
      whatsapp: 'WhatsApp',
      businessType: 'Tipo de Negocio',
      categories: 'Categorías',
      failedLoadBuyers: 'Error al cargar compradores',
    },
    // Admin Orders
    adminOrders: {
      title: 'Pedidos',
      searchPlaceholder: 'Buscar por número de pedido o empresa...',
      allStatuses: 'Todos los Estados',
      backToOrders: 'Volver a Pedidos',
      orderNotFound: 'Pedido no encontrado',
      customerInfo: 'Info del Cliente',
      company: 'Empresa',
      contact: 'Contacto',
      email: 'Correo',
      whatsapp: 'WhatsApp',
      country: 'País',
      city: 'Ciudad',
      orderNotes: 'Notas del Pedido',
      proformaSent: 'Factura Proforma Enviada',
      supplierNotes: 'Notas de Confirmación del Proveedor',
      supplierNotesHint: 'Solo interno — no visible para compradores.',
      supplierNotesPlaceholder: 'Ej. Confirmadas 12 unidades con proveedor el 2/10. Stock Grado A verificado.',
      saveNotes: 'Guardar Notas',
      savingNotes: 'Guardando...',
      notesSaved: 'Notas de confirmación del proveedor guardadas',
      updateStatus: 'Actualizar Estado',
      updating: 'Actualizando...',
      noOrders: 'No se encontraron pedidos',
      items: 'Artículos',
      total: 'Total',
      date: 'Fecha',
      downloadPdf: 'Descargar PDF',
      resendEmail: 'Reenviar Correo',
      resending: 'Reenviando...',
      emailResent: 'Notificación de estado reenviada',
      statusHistory: 'Historial de Estado',
      sendProforma: 'Enviar Proforma',
      sendingProforma: 'Enviando...',
      orderNumber: 'Pedido #',
      location: 'Ubicación',
      units: 'Unidades',
      actions: 'Acciones',
      view: 'Ver',
      loadingOrder: 'Cargando pedido...',
      failedLoadOrders: 'Error al cargar pedidos',
      failedLoadOrder: 'Error al cargar pedido',
      statusUpdatedNotified: 'comprador notificado',
      statusUpdatedNoEmail: 'Estado actualizado, pero la notificación falló',
      statusUpdatedMsg: 'Estado actualizado',
      failedUpdateStatus: 'Error al actualizar estado',
      failedSaveNotes: 'Error al guardar notas',
      emailResentSuccess: 'Correo de estado reenviado al comprador',
      failedResendEmail: 'Error al reenviar correo de estado',
      sendProformaConfirm: '¿Enviar factura proforma con instrucciones de transferencia al comprador?',
      proformaSentSuccess: '¡Factura proforma enviada exitosamente!',
      failedSendProforma: 'Error al enviar proforma',
      exportPickList: 'Exportar Lista',
      exportPickListDesc: 'Descargar lista Excel para su proveedor.',
      pickListDownloaded: 'Lista de proveedor descargada',
      failedExportPickList: 'Error al exportar lista',
      proformaInvoice: 'Factura Proforma',
      proformaInvoiceDesc: 'Generar PDF de factura proforma.',
      proformaPdfDownloaded: 'PDF proforma descargado',
      failedGeneratePdf: 'Error al generar PDF',
      nextStep: 'Siguiente',
      contactCustomer: 'Contactar Cliente',
      emailCustomer: 'Enviar Correo',
      sendProformaDesc: 'Enviar factura proforma con instrucciones de transferencia al comprador.',
    },
    // Admin Products
    adminProducts: {
      title: 'Productos',
      totalProducts: 'productos en total',
      searchPlaceholder: 'Buscar por SKU, modelo o marca...',
      allCategories: 'Todas las Categorías',
      allGrades: 'Todos los Grados',
      allStatuses: 'Todos los Estados',
      uniqueNum: 'Único #',
      brand: 'Marca',
      model: 'Modelo',
      category: 'Categoría',
      grade: 'Grado',
      costPrice: 'Costo',
      salePrice: 'Precio de Venta',
      status: 'Estado',
      noProducts: 'No se encontraron productos',
      bulkActions: 'Acciones Masivas',
      approve: 'Aprobar',
      delete: 'Eliminar',
      selected: 'seleccionados',
      sku: 'SKU',
      actions: 'Acciones',
      loadingProducts: 'Cargando productos...',
      failedLoadProducts: 'Error al cargar productos',
      productApproved: 'Producto aprobado',
      productRejected: 'Producto rechazado',
      productDeleted: 'Producto eliminado',
      failedApprove: 'Error al aprobar producto',
      failedReject: 'Error al rechazar producto',
      failedDelete: 'Error al eliminar producto',
      confirmDelete: '¿Eliminar este producto permanentemente?',
      bulkApproveFailed: 'Error en aprobación masiva',
      bulkRejectFailed: 'Error en rechazo masivo',
      shown: 'mostrados',
      approveAllFiltered: 'Aprobar todos los filtrados',
      rejectAllFiltered: 'Rechazar todos los filtrados',
      deleteAll: 'Eliminar Todos los Productos',
      deleteAllTitle: 'Eliminar Todos los Productos',
      deleteAllWarning: 'Esto eliminará permanentemente TODOS los productos y el historial de importación. Esta acción no se puede deshacer.',
      deleteAllConfirmHint: 'Escriba ELIMINAR para confirmar:',
      deleteAllConfirm: 'Eliminar Todo',
      cancel: 'Cancelar',
      approveSelected: 'Aprobar seleccionados',
      rejectSelected: 'Rechazar seleccionados',
      clear: 'Limpiar',
      totalMatched: 'Total coincidentes',
      processing: 'Procesando...',
      reject: 'Rechazar',
      approvedStatus: 'Aprobado',
      pendingReviewStatus: 'Pendiente de Revisión',
      rejectedStatus: 'Rechazado',
      importErrorStatus: 'Error de Importación',
      allFilteredProducts: 'todos los productos filtrados',
      cannotUndo: 'Esta acción no se puede deshacer.',
      countFailed: 'Error al contar productos coincidentes',
      filteredActionFailed: 'Error en acción filtrada',
      filter: 'Filtro',
      allProducts: 'Todos los productos',
    },
    // Admin Leads
    adminLeads: {
      title: 'Prospectos Mayoristas',
      leads: 'prospectos',
      searchPlaceholder: 'Buscar empresa, correo, país...',
      allStatuses: 'Todos los Estados',
      company: 'Empresa',
      contact: 'Contacto',
      email: 'Correo',
      country: 'País',
      volume: 'Volumen',
      status: 'Estado',
      date: 'Fecha',
      action: 'Acción',
      noLeads: 'No se encontraron prospectos',
      backToLeads: 'Volver a Prospectos',
      convertToBuyer: 'Convertir en Cuenta de Comprador',
      converting: 'Convirtiendo...',
      converted: 'Prospecto convertido en cuenta de comprador',
      failedConvert: 'Error al convertir prospecto',
      approve: 'Aprobar',
      reject: 'Rechazar',
      comments: 'Comentarios',
      categories: 'Categorías',
      monthlyVolume: 'Volumen Mensual',
      businessType: 'Tipo de Negocio',
      website: 'Sitio Web',
      failedLoadLead: 'Error al cargar prospecto',
      updateFailed: 'Error en actualización',
      notesSaved: 'Notas guardadas',
      failedSaveNotes: 'Error al guardar notas',
      approveConfirm: '¿Aprobar este prospecto y enviar el correo de bienvenida con acceso al inventario?',
      leadApprovedWelcome: '¡Prospecto aprobado + correo de bienvenida enviado!',
      leadApprovedNoEmail: 'Prospecto aprobado pero el correo no se envió',
      failedApprove: 'Error al aprobar',
      convertConfirm: '¿Convertir este prospecto en cuenta de comprador? Se enviará un correo de configuración.',
      buyerCreatedEmail: '¡Cuenta de comprador creada + correo de configuración enviado!',
      buyerCreatedNoEmail: 'Cuenta de comprador creada pero el correo no se envió',
      quickApprove: 'Aprobación Rápida',
      quickApproveDesc: 'Aprobar y enviar correo de bienvenida con enlace de acceso al inventario',
      approveWelcome: 'Aprobar + Enviar Bienvenida',
      sending: 'Enviando...',
      welcomeEmailSent: 'Correo de bienvenida enviado',
      convertToBuyerTitle: 'Convertir a Comprador',
      convertToBuyerDesc: 'Crear una cuenta de comprador y enviar correo de configuración',
      convertSendSetup: 'Convertir + Enviar Configuración',
      alreadyConverted: 'Ya Convertido',
      convertedToBuyer: 'Convertido a cuenta de comprador',
      manualActions: 'Acciones Manuales',
      approveNoEmail: 'Aprobar (sin correo)',
      adminNotes: 'Notas del Admin',
      notesPlaceholder: 'Notas internas sobre este prospecto...',
      saveNotes: 'Guardar Notas',
      registered: 'Registrado',
      updated: 'Actualizado',
      notSpecified: 'No especificado',
      marketingOptIn: 'Marketing Opt-In',
      yes: 'Sí',
      no: 'No',
      interestedCategories: 'Categorías de Interés',
      exportOptInCsv: 'Exportar Opt-In (CSV)',
      allCountries: 'Todos los Países',
      allOptIn: 'Todos Opt-In',
      optedIn: 'Optó',
      type: 'Tipo',
      optIn: 'Opt-In',
      confirmDeleteLead: '¿Eliminar este prospecto permanentemente?',
      leadDeleted: 'Prospecto eliminado',
      failedDeleteLead: 'Error al eliminar',
      csvExported: 'CSV exportado',
      exportFailed: 'Error en exportación',
      leadNotFound: 'Prospecto no encontrado',
      approved: 'Aprobado',
    },
    // Admin Settings
    adminSettings: {
      title: 'Configuración',
      configurePortal: 'Configure su portal LUXOR TEK',
      saveChanges: 'Guardar Cambios',
      saving: 'Guardando...',
      saved: 'Configuración guardada exitosamente',
      failedSave: 'Error al guardar configuración',
      loadingSettings: 'Cargando configuración...',
      contactSettings: 'Configuración de Contacto',
      whatsappNumber: 'Número WhatsApp Business',
      adminEmailLabel: 'Correo del Admin',
      wireTransferDetails: 'Datos de Transferencia Bancaria',
      bankName: 'Nombre del Banco',
      beneficiaryName: 'Nombre del Beneficiario',
      accountIban: 'Cuenta / IBAN',
      swiftBic: 'SWIFT / BIC',
      bankAddress: 'Dirección del Banco',
      additionalWireInstructions: 'Instrucciones Adicionales de Transferencia',
      wireInstructionsPlaceholder: 'Instrucciones adicionales para transferencias...',
      proformaNotes: 'Notas de Proforma',
      proformaNotesPlaceholder: 'Notas personalizadas para facturas proforma...',
      sharepointAutoSync: 'Auto-Sincronización SharePoint',
      sharepointAutoSyncDesc: 'Importar automáticamente archivos de inventario desde una carpeta de SharePoint. Usa preajustes de mapeo guardados para detectar categoría por carpeta/nombre de archivo.',
      sharepointSync: 'Sincronización SharePoint',
      sharepointDesc: 'Configurar importación automática de inventario desde SharePoint',
      tenantId: 'ID de Inquilino',
      clientId: 'ID de Cliente',
      clientIdApp: 'ID de Cliente (Registro de App)',
      clientSecret: 'Secreto de Cliente',
      enterClientSecret: 'Ingrese secreto de cliente',
      siteUrl: 'URL del Sitio SharePoint',
      siteUrlFormat: 'Formato: sudominio.sharepoint.com:/sites/NombreSitio',
      driveId: 'ID de Drive (opcional)',
      driveIdPlaceholder: 'Dejar vacío para usar biblioteca de documentos predeterminada',
      folderPath: 'Ruta de Carpeta',
      folderPathHint: 'Ruta dentro de la biblioteca de documentos. Archivos procesados se mueven a /processed.',
      syncInterval: 'Intervalo de Sincronización (minutos)',
      every15min: 'Cada 15 minutos',
      every30min: 'Cada 30 minutos',
      everyHour: 'Cada hora',
      every4hours: 'Cada 4 horas',
      testConnection: 'Probar Conexión',
      testing: 'Probando...',
      syncNow: 'Sincronizar Ahora',
      viewSyncLog: 'Ver Registro de Sync',
      connectionSuccessful: 'Conexión Exitosa',
      connectionFailedMsg: 'Conexión Fallida',
      connectionSuccess: 'Conexión exitosa',
      connectionFailed: 'Conexión fallida',
      filesFound: 'Archivos encontrados:',
      syncLogTitle: 'Registro de Sync (Últimos 50)',
      closeSyncLog: 'Cerrar',
      noSyncLogs: 'Sin registros de sincronización.',
      syncStarted: 'Sincronización iniciada',
      failedTriggerSync: 'Error al iniciar sincronización',
      failedLoadSyncLog: 'Error al cargar registro de sync',
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
      syncSchedule: 'Horario de Sincronización',
      lastSync: 'Última Sincronización',
      never: 'Nunca',
      saveSettings: 'Guardar Configuración',
      howWireTransferWorks: 'Cómo Funciona la Transferencia',
      wireStep1: 'El comprador envía una solicitud',
      wireStep2: 'Usted revisa y hace clic en "Enviar Proforma" en el pedido',
      wireStep3: 'El comprador recibe la factura proforma con instrucciones de transferencia',
      wireStep4: 'El estado del pedido se actualiza automáticamente a "Proforma Enviada"',
      wireStep5: 'Rastree el pago y actualice el estado según sea necesario',
    },
    // Saved Lists
    savedLists: {
      title: 'Listas Guardadas',
      empty: 'No hay listas guardadas',
      emptyMsg: 'Guarde selecciones de productos como plantillas para reordenar rápidamente.',
      createNew: 'Crear Nueva Lista',
      editList: 'Editar Lista',
      name: 'Nombre de la Lista',
      namePlaceholder: 'ej., Despliegue Escolar Q1',
      notes: 'Notas (opcional)',
      notesPlaceholder: 'Agregar notas sobre esta lista...',
      items: 'Artículos',
      itemCount: 'artículos',
      lastUpdated: 'Última actualización',
      applyToCart: 'Aplicar al Carrito',
      replace: 'Reemplazar Carrito',
      merge: 'Fusionar con Carrito',
      replaceDesc: 'Vaciar carrito actual y agregar todos los artículos',
      mergeDesc: 'Agregar artículos a carrito existente',
      deleteConfirm: '¿Eliminar esta lista guardada?',
      deleted: 'Lista eliminada',
      saved: 'Lista guardada',
      updated: 'Lista actualizada',
      failedLoad: 'Error al cargar listas',
      failedSave: 'Error al guardar lista',
      failedDelete: 'Error al eliminar lista',
      failedApply: 'Error al aplicar lista al carrito',
      applied: 'Lista aplicada al carrito',
      addedToCart: 'agregados al carrito',
      alreadyInCart: 'ya en carrito',
      skipped: 'omitidos',
      adjusted: 'ajustados',
      unavailable: 'No disponible',
      qty: 'Cant.',
      available: 'Disp.',
      removeItem: 'Eliminar artículo',
      noItems: 'No hay artículos en esta lista',
      addProducts: 'Explore productos para agregar artículos',
      maxLists: 'Límite de listas guardadas alcanzado',
      saveFromCart: 'Guardar como Lista',
      saveFromBulk: 'Guardar Selección como Lista',
      createOrOverwrite: 'Crear nueva o sobrescribir existente',
      createNewList: 'Crear nueva lista',
      overwriteExisting: 'Sobrescribir lista existente',
      selectList: 'Seleccionar lista a sobrescribir',
      saving: 'Guardando...',
      applyMode: '¿Cómo aplicar?',
      resultsTitle: 'Resultados',
      skippedItems: 'Artículos Omitidos',
      adjustedItems: 'Artículos Ajustados',
      requested: 'Solicitado',
      appliedQty: 'Aplicado',
      backToLists: 'Volver a Listas',
      viewEdit: 'Ver / Editar',
    },
    // Change Password
    changePassword: {
      title: 'Cambiar Contraseña',
      currentPassword: 'Contraseña Actual',
      newPassword: 'Nueva Contraseña',
      confirmPassword: 'Confirmar Nueva Contraseña',
      submit: 'Actualizar Contraseña',
      updating: 'Actualizando...',
      success: 'Contraseña cambiada exitosamente',
      mismatch: 'Las contraseñas no coinciden',
      tooShort: 'La nueva contraseña debe tener al menos 8 caracteres',
    },
    // Admin Import
    adminImport: {
      title: 'Importar Inventario',
      subtitle: 'Suba y mapee cualquier archivo Excel o CSV para importar productos',
      uploadFile: 'Subir Archivo',
      uploadTitle: 'Subir archivo de inventario',
      uploadDesc: 'Soporta archivos Excel (.xlsx, .xls) y CSV con cualquier formato de columnas.',
      dragDrop: 'Arrastre y suelte o haga clic para subir',
      dropOrBrowse: 'Suelte el archivo aquí o haga clic para buscar',
      anyColumnLayout: 'Cualquier diseño de columnas aceptado \u2014 mapeará columnas en el siguiente paso',
      supportedFormats: 'Formatos: .xlsx, .xls, .csv',
      unsupportedFormat: 'Formato no soportado. Use .xlsx, .xls o .csv',
      analyzing: 'Analizando...',
      analyzingFile: 'Analizando archivo...',
      processingImport: 'Procesando...',
      selectSheet: 'Seleccionar Hoja',
      selectSheetTitle: 'Seleccionar hoja',
      selectSheetDesc: 'Elija la hoja que contiene sus datos de inventario.',
      recommended: 'recomendada',
      mapColumns: 'Mapear Columnas',
      mapColumnsTitle: 'Mapear columnas',
      mapColumnsDesc: 'Mapee las columnas de su archivo a los campos del sistema. Los campos requeridos están marcados con *',
      presetsLabel: 'Preajustes:',
      saveCurrent: 'Guardar actual',
      selectType: 'Seleccionar tipo...',
      notMapped: '\u2014 Sin mapear \u2014',
      used: '(usado)',
      preview: 'Vista Previa',
      previewTitle: 'Vista previa de importación',
      previewData: 'Vista previa',
      importing: 'Importando...',
      importLabel: 'Importar',
      importComplete: 'Importación completa',
      newAdded: 'Nuevos Agregados',
      updated: 'Actualizados',
      replaceCatalog: 'Reemplazar catálogo completo',
      replaceCatalogHint: 'Archiva todos los productos existentes antes de importar. Dejar sin marcar para agregar/actualizar.',
      imported: 'Importados',
      totalRows: 'Total de filas',
      errorDetails: 'Detalles de errores',
      rows: 'filas',
      created: 'Creados',
      updated: 'Actualizados',
      skipped: 'Omitidos',
      errors: 'Errores',
      importHistory: 'Historial de Importación',
      importHistoryTitle: 'Historial de importación',
      importHistoryDesc: 'Registro de auditoría de todas las importaciones de inventario',
      noHistory: 'Sin historial de importación',
      presets: 'Preajustes',
      savePreset: 'Guardar Preajuste',
      loadPreset: 'Cargar Preajuste',
      tagCategory: 'Etiqueta categoría:',
      selectCategory: 'Seleccionar categoría...',
      categoryTrackingHint: 'Usado para seguimiento del historial de importación',
      reviewQueueTitle: 'Cola de revisión',
      productsReview: 'productos pendientes de revisión',
      showing: 'mostrando',
      allReviewed: 'Todos los productos revisados',
      approveAll: 'Aprobar todos',
      back: 'Atrás',
      next: 'Siguiente',
      executeImport: 'Ejecutar importación',
      importAnotherFile: 'Importar otro archivo',
      fileAnalyzed: 'Archivo analizado',
      sheetsFound: 'hoja(s) encontrada(s)',
      failedAnalyze: 'Error al analizar archivo',
      uniqueIdRequired: 'Único # debe ser mapeado antes de continuar',
      costOrSaleRequired: 'Precio de Costo o Precio de Venta debe ser mapeado',
      previewFailed: 'Error en vista previa',
      importFailed: 'Error en importación',
      presetSaved: 'Preajuste guardado',
      failedSavePreset: 'Error al guardar preajuste',
      presetLoaded: 'Preajuste cargado',
      mappingsApplied: 'mapeos aplicados',
      noMatchingColumns: 'No se encontraron columnas coincidentes para este preajuste',
      presetDeleted: 'Preajuste eliminado',
      failedDeletePreset: 'Error al eliminar preajuste',
      productApproved: 'Producto aprobado',
      failedApprove: 'Error al aprobar',
      productRejected: 'Producto rechazado',
      failedReject: 'Error al rechazar',
      allApproved: 'Todos los productos aprobados',
      failedApproveAll: 'Error al aprobar todos',
      confirmApproveAll: '¿Aprobar todos los productos?',
      deleteLogConfirm: '¿Eliminar este registro de importación y su archivo original?',
      importLogDeleted: 'Registro de importación eliminado',
      failedDeleteLog: 'Error al eliminar',
      downloadFailed: 'Error en descarga',
      issues: 'Problemas',
      dateCol: 'Fecha',
      fileCol: 'Archivo',
      categoryCol: 'Categoría',
      importedCol: 'Importados',
      failedCol: 'Fallidos',
      statusCol: 'Estado',
      userCol: 'Usuario',
      actionsCol: 'Acciones',
      skuCol: 'SKU',
      brandCol: 'Marca',
      modelCol: 'Modelo',
      costCol: 'Costo',
      saleCol: 'Venta',
      gradeCol: 'Grado',
      errorCol: 'Error',
    },
  },
};

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let result = translations[lang] || translations.en;
  for (const key of keys) {
    result = result?.[key];
  }
  return result || path;
};
